import { render, staticRenderFns } from "./AssignmentsFilters.vue?vue&type=template&id=723c5c61&scoped=true&"
import script from "./AssignmentsFilters.vue?vue&type=script&lang=js&"
export * from "./AssignmentsFilters.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentsFilters.vue?vue&type=style&index=0&id=723c5c61&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723c5c61",
  null
  
)

export default component.exports